// jQuery
global.jQuery = require('jquery');
global.$ = global.jQuery;

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, {passive: true});
    }
};
jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, {passive: true});
    }
};


/** Image data-src observer **/
const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const img = entry.target;
            img.srcset = img.getAttribute('data-srcset');
            img.removeAttribute('data-srcset');
            observer.unobserve(img);

        }
    });
});

document.querySelectorAll('img[data-srcset]').forEach(img => {
    observer.observe(img);
});





$(function () {

    let app = require('./modules/core')();
    app.initBootstrap();
    app.initLazyLoad();
    //app.initLightbox(); // Use Spotlight for galleries - comment this in if you need it
    app.initSlickCarousel();
    app.scrollToAnchor();
    //app.scrollToAccordionItem();
    app.detectUrlScrollHash();
    app.convertCryptedEmails();
    app.initMobileMenu();
    app.initRrssb();
    app.initPopups();
    app.initSpotlightJs();
    app.initTingleModalJs();

    //app.navDropdownHover(); // Hover instead of click on Nav dropdowns
    //app.initDatePicker();
    app.initWowJs();
    app.initStickyEl();
    app.keepTokenAlive();
    //app.initTooltips();
    app.announcementBarDismiss();
    app.initSearchBar();
    //app.QuoteWrapper();
    app.AdDeviceDector();
    // let googleMaps = require('./modules/google-maps')();
    // googleMaps.assign();


    $(".megamenu").on("click", function (e) {
        e.stopPropagation();
    });

    /*Search*/
    $(function () {
        let timeout = null;

        $('#GlobalSearch').keyup(function () {
            $('.results-container').html('').addClass('d-none');

            //clearTimeout(timeout); // this will clear the recursive unneccessary calls

            //timeout = setTimeout(() => {

            if (window.google_tag_manager)
                gtag('event', 'search', {
                    'event_category': 'engagement',
                    'event_label': $(this).val()
                });

            $.ajax({
                type: 'POST',
                url: '/api/search',
                data: {search: $(this).val()},
                dataType: 'json',
                headers: {'x-csrf-token': $('meta[name=csrf-token]').attr('content')},
                statusCode: {
                    200: function (result) {
                        console.log(result);

                        if (result.count)
                            $('.results-container').removeClass('d-none').html(result.html)

                        return true;
                    },

                    500: function (xhr) {
                        $('.results-container').addClass('d-none')
                        return false;
                    }
                }
            });
            //, 100);

        }).on('focusout', function () {

            setTimeout(function () {
                $('.results-container').html('').addClass('d-none');
            }, 200);
        });


        $('.hide-on-submit').click(function(){
            $(this).attr('disabled', 'disabled')
                .addClass('rounded-max')
                .html('<i class="fa fa-spin fa-spinner"></i>');
            $(this).parents('form').submit();
        });
    });


    $('.desktop-hamburger, .desktop-burger-nav .close').on('click', function (e) {
        e.preventDefault();
        $('body').toggleClass('desktop-burger-nav-open');
    });

});


